import styled, { css } from 'styled-components';
import { cornerRadiusM, scale010, scale020, scale060, scale160, xdlColorBackgroundTertiary, xdlColorControlFillSecondary, xdlColorDisabledStrong, } from '@xingternal/tokens';
import maskImage from '../assets/super-ellipse-mask.svg';
// *** Components ***
const Wrapper = styled.div `
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
const SuperEllipse = styled.div `
  min-height: ${scale160};
  min-width: ${scale160};
  pointer-events: none;

  & .strokeWidth {
    stroke: ${xdlColorBackgroundTertiary};
  }
`;
const ImageContainer = styled.div `
  mask-image: url(${maskImage});
  mask-position: center;
  mask-repeat: no-repeat;

  /* Remove border for modern browsers */
  @supports (mask-image: url('')) {
    border: 0;
  }

  ${({ $blur }) => $blur
    ? css `
          /* Background color for IE11 (as blur) fallback */
          background-color: ${xdlColorDisabledStrong};

          /* Fake border just for IE11 (while blur) */
          border-color: ${xdlColorBackgroundTertiary};
          border-radius: ${cornerRadiusM};
          border-style: solid;
          border-width: ${scale010};

          @supports (mask-image: url('')) {
            background-color: transparent;
            border: 0;
          }
        `
    : null};
`;
const Image = styled.img `
  background-color: ${xdlColorControlFillSecondary};

  /* Fake border just for IE11 */
  border-color: ${xdlColorBackgroundTertiary};
  border-radius: ${cornerRadiusM};
  border-style: solid;
  border-width: ${scale010};

  display: block;
  height: calc(100% - ${scale020});
  margin-left: ${scale010};
  margin-top: ${scale010};
  min-height: ${scale160};
  min-width: ${scale160};
  width: calc(100% - ${scale020});
  z-index: 0;

  ${({ $blur }) => $blur
    ? css `
          filter: blur(${scale060});
          pointer-events: none;

          /* Hide image in IE11 as fallback for a blur */
          visibility: hidden;

          /* Show blur for modern browsers */
          @supports (mask-image: url('')) {
            visibility: visible;
          }
        `
    : null};
`;
const ImageSvgBorder = styled.svg `
  bottom: ${scale010};

  /* Hide border for IE11 */
  display: none;

  height: calc(100% - 4px);
  left: ${scale010};
  min-height: ${scale160};
  min-width: ${scale160};
  position: absolute;
  right: ${scale010};
  stroke-width: ${scale010};
  top: ${scale010};
  width: calc(100% - ${scale020});
  z-index: 1;

  /* Remove border for modern browsers */
  @supports (mask-image: url('')) {
    display: block;
  }
`;
export const Styled = {
    Wrapper,
    SuperEllipse,
    ImageContainer,
    Image,
    ImageSvgBorder,
};
//# sourceMappingURL=super-ellipse-responsive.styles.js.map